import { ADD_CART, REMOVE_CART, RESET_CART, RESET_CART_TIMESLOTS, SET_CART, UPDATE_CART } from 'services/redux/action-types'
import { cartConstants } from "services/redux/cart/constants";
import _ from "lodash";
import { bookingOptions, isBookForMyself } from "utils/constants/booking-constants";
import { createSelector } from 'reselect'
import { dataConstants } from 'services/redux/data/constants'

const initialState = {
	[ cartConstants.BUILDING_TREE ] : undefined,
	
	[ cartConstants.BOOK_DATE ]: undefined, // Moment is not available/ready here!
	
	[ cartConstants.BOOK_FOR_OPTION ]: bookingOptions.MYSELF,
	
	[ cartConstants.CAPACITIES ]: {},
	
	// Timeslots
	[ cartConstants.TIMESLOTS_SELECTED ]: false,
	
	[ cartConstants.TIMESLOTS ]: {},
	
	[ cartConstants.TIMESLOTS_LUNCH_OPTIONS ]: {},
	[ cartConstants.TIMESLOTS_TRANSPORT_LICENSE_PLATES]: {},
	[ cartConstants.TIMESLOTS_TRANSPORT_DEFAULT_LICENSE_PLATE]: null,
	
	// Extra
	[ cartConstants.BOOKING_REJECT ]: [],
	[ cartConstants.BOOKING_EXTERNAL_PERSONS ]: {},
	[ cartConstants.BOOKING_COWORKERS ]: {},
};

export default function data( state = initialState, action ) {
	switch (action.type) {
		case SET_CART:
			state = {
				...state,
				[action.key]: action.payload
			}
			
			return {
				...state,
				...timeslotsSelected( state ),
			};
			
		case ADD_CART:
			state = {
				...state,
				...{
					[action.key]: {
						..._.get( state, action.key, {} ),
						...action.payload
					}
				}
			}
			
			return {
				...state,
				...timeslotsSelected( state ),
			};
			
		case UPDATE_CART:
			let items = _.get( state, action.key, {} );
			
			items[ action.payloadKey ] = {
				..._.get( items, action.payloadKey, {} ),
				...action.payload
			};
			
			state = {
				...state,
				...{
					[action.key]: {
						...items
					}
				}
			}
			
			return {
				...state,
				...timeslotsSelected( state ),
			};
		
		case REMOVE_CART:
			const value = _.get( state, action.key, {} );

			// Remove it from the list
			const removedValue = _.pickBy( value, ( o, i ) => {
				return i !== action.payload;
			});
			
			state = {
				...state,
				...{
					[action.key]: {
						...removedValue
					}
				}
			}
			
			return {
				...state,
				...timeslotsSelected( state ),
			};

		case RESET_CART_TIMESLOTS:
			state = {
				...state,
				[ cartConstants.TIMESLOTS ]: {},
				[ cartConstants.TIMESLOTS_LUNCH_OPTIONS ]: {},
				[ cartConstants.TIMESLOTS_TRANSPORT_LICENSE_PLATES ]: {},
				[ cartConstants.TIMESLOTS_TRANSPORT_DEFAULT_LICENSE_PLATE ]: {},
			}
			
			return {
				...state,
				...timeslotsSelected( state ),
			};

		case RESET_CART:
			const bookDate = state[ cartConstants.BOOK_DATE ];
			
			return {
				...initialState,
				[ cartConstants.BOOK_DATE ]: bookDate,
			};
			
		default:
			// Nothing
	}
	
	return state;
}

const timeslotsSelected = ( state ) => {
	return {
		[ cartConstants.TIMESLOTS_SELECTED ]: !_.isEmpty( state[ cartConstants.TIMESLOTS ] )
	};
}

export const selectCartEmployees = createSelector(
	(state) => {
		return state.data[dataConstants.EMPLOYEE];
	},
	(state) => {
		return state.cart[cartConstants.BOOKING_COWORKERS];
	},
	(state) => {
		return state.cart[cartConstants.BOOKING_EXTERNAL_PERSONS];
	},
	(state) => {
		return state.cart[cartConstants.BOOK_FOR_OPTION];
	},
	( employee, coworkers, externals, bookForOption ) => {
		let result = {};
		
		// First add employee self (if required)
		if( isBookForMyself( bookForOption ) ) {
			result[ employee.guid ] = employee;
		}
		
		// Then add the rest
		result = {
			...result,
			...coworkers,
			...externals
		}
		
		return result
	}
)

export const selectCartTimeslot = createSelector(
	[
		(state) => {
			return state.cart[cartConstants.TIMESLOTS];
		},
		(state, key) => {
			return key;
		}
	],
	( timeslots, key ) => {
		return _.get( timeslots, key, {} )
	}
)

export const selectCartTimeslotsByKind = createSelector(
	[
		(state) => {
			return state.cart[cartConstants.TIMESLOTS];
		},
		(state, kind) => {
			return kind;
		}
	],
	( timeslots, kind ) => {
		return _.filter( timeslots, ( o ) => {
			return o?.kind === kind;
		} )
	}
)
